import React from "react";
import TBBImage from "utils/TBBImage";
import RichText from "utils/RichText";

const TwoColumnImageQuote = ({ blok }) => {
  return (
    <div className="my-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="relative flex flex-col items-center justify-center gap-10 md:flex-row lg:gap-20">
          <div className="w-full md:w-1/2">
            <TBBImage
              image={blok.image}
              className="mx-auto max-w-lg md:max-w-none"
            />
          </div>
          <div className="w-full text-[#091DF3] md:w-1/2">
            <div className="text-[28px] leading-none lg:text-[36px] xl:text-[44px]">
              <RichText paragraph_classes="xl:text-[44px] lg:text-[36px] text-[28px] leading-[50px]">
                {blok.quote}
              </RichText>
            </div>
            <div className="mt-10 flex flex-col text-2xl lg:mt-12 xl:mt-14">
              <span>{blok.person}</span>
              <span>{blok.job_title}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoColumnImageQuote;
